import React from "react";

import AboutPart from "./AboutSection";
import Testimonial from "./TestimonialSection";
import Feature from "./FeatureSection";
import Instructor from "./InstructorSection";
import BuilddingSection from "./BuilddingSection";
import InfoFirstSection from "./InfoFirstSection";
import InfoSecondSection from "./InfoSecondSection";
import InfoThirdSection from "./InfoThirdSection";
import LicenseSection from "./LicenseSection";

const AboutMain = () => {
  return (
    <>
      {/* <AboutPart /> */}

      <InfoFirstSection />

      <InfoSecondSection />

      <InfoThirdSection />

      <LicenseSection />

      <BuilddingSection />

      {/* <Feature /> */}

      {/* <Instructor /> */}
{/* 
      <Testimonial /> */}
    </>
  );
};

export default AboutMain;
